import moment from 'moment-timezone';

export const baseRoute = window.location.pathname.startsWith('/order/menu2/')
    ? `/order/menu2/${window.vendor}`
    : (
        window.location.pathname.includes('/pos/')
        ? `/pos/menu/${window.vendor}`
        : `${process.env.REACT_APP_BASE_ROUTE}/${window.vendor}`
    );

export const apiHost = window.location.hostname === 'localhost' ? window.location.origin : process.env.REACT_APP_API_HOST;

export const minutesToDouble = (minutes) => {
    if (0 === minutes) { return 0; }
    
    const rate = 1 / 60;
  
    return minutes * rate;
};

export const getWorkHours2 = ({timezone, business_hours, todayNumber, last_order_time}, isLastOrderTime = false) => {
    const currentDate = moment().tz(timezone);
    // console.log(currentDateTime, moment(currentDateTime), moment(currentDateTime).tz(timezone))
    // const currentDate = moment(currentDateTime).tz(timezone);
    const currentMinutes = currentDate.minute();
    // const currentMinutes = currentTimeValue.minutes;
    const lastMinutes = currentMinutes + (isLastOrderTime ? +last_order_time : 0);
    const currentHour = currentDate.hour() + minutesToDouble(currentMinutes);
    // const currentLastHour = currentDate.hour() + minutesToDouble(lastMinutes);
    // const currentHour = currentTimeValue.hours + minutesToDouble(currentTimeValue.minutes);
    // const currentHour = currentTimeValue.hours + minutesToDouble(currentMinutes);
    // const currentLastHour = currentTimeValue.hours + (lastMinutes > 60 ? 1 : 0) + minutesToDouble(lastMinutes > 60 ? lastMinutes - 60 : lastMinutes);
    const currentLastHour = currentHour + (lastMinutes > 60 ? 1 : 0) + minutesToDouble(lastMinutes > 60 ? lastMinutes - 60 : lastMinutes);
    
    const cDate = business_hours.find(h => h.dayNumber === todayNumber);

    if (cDate) {
        const beginHour = +cDate.beginHour;
        const endHour = +cDate.endHour;

        if (beginHour <= currentHour && currentLastHour <= endHour) {
            return cDate;
        }
    }

    const cDate2 = business_hours.find(h => h.dayNumber === (todayNumber === 0 ? 6 : (todayNumber - 1)));

    if (cDate2) {
        const endHour = +cDate2.endHour;

        if (endHour >= 24 && currentLastHour <= (endHour - 24)) {
            return cDate2;
        }
    }

    return null;
};

export const getWorkHours = ({timezone, business_hours, todayNumber, last_order_time}, isLastOrderTime = false) => {
    const currentDate = moment().tz(timezone);
    const currentMinutes = currentDate.minute();
    const lastMinutes = (isLastOrderTime && +last_order_time > 0 ? +last_order_time : 0);
    // const currentHour = currentDate.hour() + minutesToDouble(currentMinutes);
    // const currentLastHour = currentHour + (lastMinutes > 60 ? 1 : 0) + minutesToDouble(lastMinutes > 60 ? lastMinutes - 60 : lastMinutes);

    const currentHour = currentDate.hour() + minutesToDouble(currentMinutes);
    const currentLastHour = currentDate.hour() + minutesToDouble(lastMinutes);
    
    const cDate = business_hours.find(h => h.dayNumber === todayNumber);
    // console.log({cDate, minutesToDouble: minutesToDouble(lastMinutes), currentHour})
    if (cDate) {
        let [beginHour, beginMinutes] = cDate.beginHour.split('.');
        let [endHour, endMinutes] = cDate.endHour.split('.');

        if (!beginMinutes) { beginMinutes = 0; }
        if (!endMinutes) { endMinutes = 0; }
        
        beginMinutes = +beginMinutes > 0 ? 0.50 : 0;
        endMinutes = +endMinutes > 0 ? 0.50 : 0;
        // console.log(
        //     {
        //         beginHour: +beginHour,
        //         beginMinutes,
        //         currentHour,
        //         endHour: +endHour,
        //         endMinutes,
        //         c1: (+beginHour + beginMinutes) <= currentHour,
        //         c2: currentHour < (+endHour + endMinutes - minutesToDouble(lastMinutes)),
        //         minutesToDouble: minutesToDouble(lastMinutes)
        //     }
        // )
        if ((+beginHour + beginMinutes) <= currentHour && currentHour < (+endHour + endMinutes - minutesToDouble(lastMinutes))) {
            return cDate;
        }
    }

    const cDate2 = business_hours.find(h => h.dayNumber === (todayNumber === 0 ? 6 : (todayNumber - 1)));
    // console.log({cDate2})
    if (cDate2) {
        let [endHour, endMinutes] = cDate2.endHour.split('.');
        
        if (!endMinutes) { endMinutes = 0; }
        
        endMinutes = +endMinutes > 0 ? 0.50 : 0;

        if ((+endHour + endMinutes) >= 24 && currentHour < ((+endHour + endMinutes - minutesToDouble(lastMinutes)) - 24)) {
            return cDate2;
        }
    }

    return null;
};

export const getDeliveryWorkHours2 = ({timezone, delivery_hours, todayNumber, last_delivery_order_time}, isLastOrderTime = false) => {
    const currentDate = moment().tz(timezone);
    // const currentDate = moment(currentDateTime).tz(timezone);
    const currentMinutes = currentDate.minute();
    // const currentMinutes = currentTimeValue.minutes;
    const lastMinutes = currentMinutes + (isLastOrderTime ? +last_delivery_order_time : 0);
    const currentHour = currentDate.hour() + minutesToDouble(currentMinutes);
    // const currentLastHour = currentDate.hour() + minutesToDouble(lastMinutes);
    // const currentHour = currentTimeValue.hours + minutesToDouble(currentTimeValue.minutes);
    // const currentHour = currentTimeValue.hours + minutesToDouble(currentMinutes);
    // const currentLastHour = currentTimeValue.hours + (lastMinutes > 60 ? 1 : 0) + minutesToDouble(lastMinutes > 60 ? lastMinutes - 60 : lastMinutes);
    const currentLastHour = currentHour + (lastMinutes > 60 ? 1 : 0) + minutesToDouble(lastMinutes > 60 ? lastMinutes - 60 : lastMinutes);

    const cDate = delivery_hours.find(h => h.dayNumber === todayNumber);

    if (cDate) {
        const beginHour = +cDate.beginHour;
        const endHour = +cDate.endHour;

        if (beginHour <= currentHour && currentLastHour <= endHour) {
            return cDate;
        }
    }

    const cDate2 = delivery_hours.find(h => h.dayNumber === (todayNumber === 0 ? 6 : (todayNumber - 1)));

    if (cDate2) {
        const endHour = +cDate2.endHour;

        if (endHour >= 24 && currentLastHour <= (endHour - 24)) {
            return cDate2;
        }
    }

    return null;
};

export const getDeliveryWorkHours = ({timezone, delivery_hours, todayNumber, last_delivery_order_time}, isLastOrderTime = false) => {
    const currentDate = moment().tz(timezone);
    const currentMinutes = currentDate.minute();
    const lastMinutes = currentMinutes + (isLastOrderTime && +last_delivery_order_time > 0 ? +last_delivery_order_time : 0);

    const currentHour = currentDate.hour() + minutesToDouble(currentMinutes);
    const currentLastHour = currentDate.hour() + minutesToDouble(lastMinutes);

    const cDate = delivery_hours.find(h => h.dayNumber === todayNumber);

    if (cDate) {
        let [beginHour, beginMinutes] = cDate.beginHour.split('.');
        let [endHour, endMinutes] = cDate.endHour.split('.');

        if (!beginMinutes) { beginMinutes = 0; }
        if (!endMinutes) { endMinutes = 0; }

        beginMinutes = +beginMinutes > 0 ? 0.50 : 0;
        endMinutes = +endMinutes > 0 ? 0.50 : 0;

        if ((+beginHour + beginMinutes) <= currentHour && currentHour < (+endHour + endMinutes - minutesToDouble(lastMinutes))) {
            return cDate;
        }
    }

    const cDate2 = delivery_hours.find(h => h.dayNumber === (todayNumber === 0 ? 6 : (todayNumber - 1)));

    if (cDate2) {
        let [endHour, endMinutes] = cDate2.endHour.split('.');

        if (!endMinutes) { endMinutes = 0; }

        endMinutes = +endMinutes > 0 ? 0.50 : 0;

        if ((+endHour + endMinutes) >= 24 && currentHour < ((+endHour + endMinutes - minutesToDouble(lastMinutes)) - 24)) {
            return cDate2;
        }
    }

    return null;
};

export const isInWorkHours = ({business_hours}, period, scheduleTime) => {
    const selectedDate = business_hours.find(h => h.dayNumber === period.dayNumber);
    const [day, time] = scheduleTime.split(' ');
    let [hours, minutes] = time.split('.');
    const scheduleHour = +day * 24 + +hours + (+minutes > 0 ? 0.30 : 0);
    
    if (selectedDate) {
        let [beginHour, beginMinutes] = selectedDate.beginHour.split('.');
        let [endHour, endMinutes] = selectedDate.endHour.split('.');

        if (!beginMinutes) { beginMinutes = 0; }
        if (!endMinutes) { endMinutes = 0; }

        beginMinutes = +beginMinutes > 0 ? 0.30 : 0;
        endMinutes = +endMinutes > 0 ? 0.30 : 0;

        if ((+beginHour + beginMinutes) <= scheduleHour && scheduleHour <= (+endHour + endMinutes)) {
            return true;
        }
    }

    return false;
};

export const getActiveGifts = (gifts, categories, cart, {timezone, todayNumber}) => {
    const currentDate = moment().tz(timezone);
    const currentMinutes = currentDate.minute();

    const currentHour = currentDate.hour() + minutesToDouble(currentMinutes);

    return gifts.filter(gift => {
        if (gift.is_specific_display) {
            const isActive = gift.business_hours.some(business_hour => {
                const [dayNumber, hourBegin, hourEnd] = business_hour.split('|');

                return +dayNumber === todayNumber
                    && +hourBegin <= currentHour
                    && currentHour < +hourEnd;
            });

            if (!isActive) {
                return false;
            }
        }

        if ('category' === gift.threshold_from) {
            const category = categories.find((category, index) => category.id === gift.selected_threshold_category);
            if (!category) {
                return false;
            }

            const itemIds = category.items.map(({ id }) => id);
            if (!cart.some(item => itemIds.includes(item.id))) {
                return false;
            }

            const items = cart.filter(item => itemIds.includes(item.id));

            if ('value' === gift.type) {
                const itemsCost = items.map(item => (item.price + Object
                    .entries(item.selectedOptions || {})
                    .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                    .reduce((acc, p) => acc + p, 0)) * item.quantity);
                const totalCost = itemsCost.reduce((acc, cur) => acc + cur, 0);
                return gift.threshold_value <= totalCost;
            }

            const totalQuantity = items.reduce((acc, cur) => acc + cur.quantity, 0);
            return gift.threshold_quantity <= totalQuantity;
        }

        if ('categories' === gift.threshold_from) {
            const categoriesList = categories.filter((category, index) => gift.selected_threshold_categories.includes(category.id));
            
            if (0 === categoriesList.length) {
                return false;
            }

            const itemIds = categoriesList.reduce((acc, cur) => acc.concat(cur.items.map(({ id }) => id)), []);
            
            if (!cart.some(item => itemIds.includes(item.id))) {
                return false;
            }

            const items = cart.filter(item => itemIds.includes(item.id));
            
            if ('value' === gift.type) {
                const itemsCost = items.map(item => (item.price + Object
                    .entries(item.selectedOptions || {})
                    .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                    .reduce((acc, p) => acc + p, 0)) * item.quantity);
                const totalCost = itemsCost.reduce((acc, cur) => acc + cur, 0);
                return gift.threshold_value <= totalCost;
            }

            const totalQuantity = items.reduce((acc, cur) => acc + cur.quantity, 0);
            return gift.threshold_quantity <= totalQuantity;
        }

        if ('item' === gift.threshold_from) {
            const item = cart.find(item => item.id === gift.selected_threshold_item);
            if (!item) {
                return false;
            }

            if ('value' === gift.type) {
                const itemCost = (item.price + Object
                    .entries(item.selectedOptions || {})
                    .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                    .reduce((acc, p) => acc + p, 0)) * item.quantity;
                return gift.threshold_value <= itemCost;
            }

            return gift.threshold_quantity <= item.quantity;
        }

        if ('entire-menu' === gift.threshold_from) {
            if ('value' === gift.type) {
                const itemsCost = cart.map(item => (item.price + Object
                    .entries(item.selectedOptions || {})
                    .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                    .reduce((acc, p) => acc + p, 0)) * item.quantity)
                    .reduce((acc, cur) => acc + cur, 0);
                // const itemsCost = cart.reduce((acc, cur) => acc + (cur.price * cur.quantity), 0);
                return gift.threshold_value <= itemsCost;
            }

            const itemsQuantity = cart.reduce((acc, cur) => acc + cur.quantity, 0);

            return gift.threshold_quantity <= itemsQuantity;
        }

        return false;
    });
};

export const calculateGiftItemPrice = (costType, rate, value, price) => {
    if ('percentage' === costType) {
        return price - (price * (rate / 100));
    }
    if ('value' === costType) {
        const cost = price - value;
        return cost > 0 ? cost : 0.00;
    }
    return 0.00;
};

export const getCurrentThresholdGiftsQuantity = (gift, categories, cart) => {
    if ('category' === gift.threshold_from) {
        const category = categories.find((category, index) => category.id === gift.selected_threshold_category);
        if (!category) {
            return 0;
        }

        const itemIds = category.items.map(({ id }) => id);
        if (!cart.some(item => itemIds.includes(item.id))) {
            return 0;
        }

        const items = cart.filter(item => itemIds.includes(item.id));

        if ('value' === gift.type) {
            const itemsCost = items.map(item => (item.price + Object
                .entries(item.selectedOptions || {})
                .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                .reduce((acc, p) => acc + p, 0)) * item.quantity);
            
            const totalCost = itemsCost.reduce((acc, cur) => acc + cur, 0);
            
            if (gift.threshold_value <= totalCost) {
                return Math.floor(totalCost / gift.threshold_value) * gift.quantity;
            }
        }

        const totalQuantity = items.reduce((acc, cur) => acc + cur.quantity, 0);
        
        if (totalQuantity >= gift.threshold_quantity) {
            return Math.floor(totalQuantity / gift.threshold_quantity) * gift.quantity;
        }
    }

    if ('categories' === gift.threshold_from) {
        const categoriesList = categories.filter((category, index) => gift.selected_threshold_categories.includes(category.id));
        
        if (0 === categoriesList.length) {
            return 0;
        }

        const itemIds = categoriesList.reduce((acc, cur) => acc.concat(cur.items.map(({ id }) => id)), []);
        
        if (!cart.some(item => itemIds.includes(item.id))) {
            return 0;
        }

        const items = cart.filter(item => itemIds.includes(item.id));

        if ('value' === gift.type) {
            const itemsCost = items.map(item => (item.price + Object
                .entries(item.selectedOptions || {})
                .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                .reduce((acc, p) => acc + p, 0)) * item.quantity);
            
            const totalCost = itemsCost.reduce((acc, cur) => acc + cur, 0);
            
            if (gift.threshold_value <= totalCost) {
                return Math.floor(totalCost / gift.threshold_value) * gift.quantity;
            }
        }

        const totalQuantity = items.reduce((acc, cur) => acc + cur.quantity, 0);
        
        if (totalQuantity >= gift.threshold_quantity) {
            return Math.floor(totalQuantity / gift.threshold_quantity) * gift.quantity;
        }
    }

    if ('item' === gift.threshold_from) {
        const item = cart.find(item => item.id === gift.selected_threshold_item);
        if (!item) {
            return false;
        }

        if ('value' === gift.type) {
            const itemCost = (item.price + Object
                .entries(item.selectedOptions || {})
                .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                .reduce((acc, p) => acc + p, 0)) * item.quantity;

            if (gift.threshold_value <= itemCost) {
                return Math.floor(itemCost / gift.threshold_value) * gift.quantity;
            }
        }
        
        if (item.quantity >= gift.threshold_quantity) {
            return Math.floor(item.quantity / gift.threshold_quantity) * gift.quantity;
        }
    }

    if ('entire-menu' === gift.threshold_from) {
        if ('value' === gift.type) {
            const itemsCost = cart.map(item => (item.price + Object
                .entries(item.selectedOptions || {})
                .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + l.price, 0))
                .reduce((acc, p) => acc + p, 0)) * item.quantity)
                .reduce((acc, cur) => acc + cur, 0);

            if (gift.threshold_value <= itemsCost) {
                return Math.floor(itemsCost / gift.threshold_value) * gift.quantity;
            }
        }

        const itemsQuantity = cart.reduce((acc, cur) => acc + cur.quantity, 0);
        
        if (itemsQuantity >= gift.threshold_quantity) {
            return Math.floor(itemsQuantity / gift.threshold_quantity) * gift.quantity;
        }
    }

    return 0;
};